import type { SidebarItemState } from '@/pages/company-drawer/company-overview/set-irq-modal/types'

export const itemRowClasses: Record<SidebarItemState, string> = {
  active: '',
  visited: 'hover:bg-main-background-interactive-list-hover',
  idle: 'hover:bg-main-background-interactive-list-hover',
  conditional: 'cursor-default',
}

export const itemIconClasses: Record<SidebarItemState, string> = {
  active: 'text-main-foreground-accent',
  visited: 'text-main-foreground-secondary',
  idle: 'text-main-foreground-tertiary group-hover:text-main-foreground-accent',
  conditional: 'text-main-foreground-tertiary',
}

export const itemTextClasses: Record<SidebarItemState, string> = {
  active: 'text-main-foreground-accent',
  visited: 'text-main-foreground-primary',
  idle: 'text-main-foreground-primary group-hover:text-main-foreground-accent',
  conditional: 'text-main-foreground-tertiary',
}
